import { render, staticRenderFns } from "./SaleOrder.vue?vue&type=template&id=61eeff33&"
import script from "./SaleOrder.vue?vue&type=script&lang=ts&"
export * from "./SaleOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports